import { createContext } from 'react';
import type { OidcContextProps } from './types.js';

export const OidcContext = createContext<OidcContextProps | undefined>(
  undefined,
);
